import React from "react";
import AdminRegistrationCard from "./AdminRegistrationCard";

const AdminRegistrationCardList = ({queriedRegistrations}) => {
	return (
		<div>
			{ queriedRegistrations?.map((queriedRegistration) => <AdminRegistrationCard 
         queriedRegistration={queriedRegistration}/>)}
		</div>	
	)
}

export default AdminRegistrationCardList;